<template>
  <div id="app">
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
    <router-view/>
  </div>
</template>

<style>
html, body, div, ul, li, h1, h2, h3, h4, h5, h6, p, dl, dt, dd, ol, form, input, textarea, th, td, select {
    margin: 0;
    padding: 0;
}
/* #app{
  position: relative;
} */
</style>

<script>
export default {
  name:'app',
  mounted(){console.log(arguments);},
  created(){console.log(arguments);},
  beforeRouteEnter (to, from, next) {
    console.log(arguments);
     next();
  }
}
</script>

